import { FaxTypes } from '@frontend/api-fax';
import { Icon } from '@frontend/icons';
import type { CommonHTMLAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { STATUS_ICON_MAP } from '../../constants';

type MessageStatusIndicatorProps = {
  status: FaxTypes.FaxStatus;
  size?: number;
  iconSize?: number;
} & CommonHTMLAttributes;

export const ListItemStatus = ({ status, size = 16, iconSize = 12, ...rest }: MessageStatusIndicatorProps) => {
  const { name, backgroundColor, iconColor, iconColorCss } = STATUS_ICON_MAP[status];

  return (
    <figure
      css={{
        borderRadius: theme.borderRadius.small,
        backgroundColor,
        width: size,
        minWidth: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 0,
      }}
      {...rest}
    >
      <Icon name={name} color={iconColor} size={iconSize} css={iconColorCss ? { color: iconColorCss } : undefined} />
    </figure>
  );
};
